//const BASE_URL = "https://lssi-backend-82b2d4696f39.herokuapp.com";
//const BASE_URL = "https://lssi-backend-82b2d4696f39.herokuapp.com"
const BASE_URL = "https://api.lssi-fin.com"

export const API_URL = `${BASE_URL}/api/clients/`;
export const API_URL_partners = `${BASE_URL}/api/partners/`;
export const API_URL_productos = `${BASE_URL}/api/productos/`;
export const API_URL_product_types = `${BASE_URL}/api/product_types/`;
export const API_URL_clasificacion_productos = `${BASE_URL}/api/clasificacion-productos/`;
export const API_URL_historical_kpis = `${BASE_URL}/api/historical_kpis/`;
export const API_URL_historical_kpis_meta = `${BASE_URL}/api/historical_kpis/meta/`;
export const API_URL_client_imports_status = `${BASE_URL}/api/client_imports/status/`;
export const API_URL_client_imports_preview = `${BASE_URL}/api/client_imports/preview/`;
export const API_URL_client_imports_apply = `${BASE_URL}/api/client_imports/apply/`;
export const API_URL_proyectos = `${BASE_URL}/api/proyectos/`;
export const API_URL_sedes = `${BASE_URL}/api/sedes/`;
export const API_URL_partidas = `${BASE_URL}/api/partidas/`;
export const API_URL_instructores = `${BASE_URL}/api/instructores/`;
export const API_URL_costos = `${BASE_URL}/api/costos/`;
export const API_URL_movimientos = `${BASE_URL}/api/movimientos/`;
export const API_URL_partidas_curso = `${BASE_URL}/api/cursos/`;
export const API_URL_comision_multi = `${BASE_URL}/api/comision_multi/`;
export const API_URL_comision_multi_codes = `${BASE_URL}/api/comision_multi_codes/`;
export const API_URL_utilidad = `${BASE_URL}/api/utilidad/`;
export const API_URL_movimientos_semana = `${BASE_URL}/api/sum_movimiento/`;
export const API_URL_partidas_curso_abierto = `${BASE_URL}/api/curso_abierto/`;
export const API_URL_SPC= `${BASE_URL}/api/spc/`;
export const API_URL_SPC_List= `${BASE_URL}/api/spc_list/`;
export const API_URL_movimiento_summary= `${BASE_URL}/api/movimiento-summary/`;
export const API_URL_BoxScore= `${BASE_URL}/api/BoxScore/`;
export const API_URL_BoxScoreAll= `${BASE_URL}/api/BoxScoreAll/`;
export const API_URL_proyecto_con_causa= `${BASE_URL}/api/proyecto_con_causa/`;
export const API_URL_utilidades_partners= `${BASE_URL}/api/utilidades-api/`;
export const API_URL_utilidades_byproject= `${BASE_URL}/api/join_utilidades_miembros/`;
export const API_URL_abierto_miembros= `${BASE_URL}/api/join_curso_abierto_miembros/`;
export const API_URL_instructores_list= `${BASE_URL}/api/instructores_list/`;
export const API_URL_estudiantes_list= `${BASE_URL}/api/estudiantes_list/`;
export const API_URL_lideres= `${BASE_URL}/api/distinct_lider/`;
export const API_URL_lideres_profit= `${BASE_URL}/api/lider_profits/`;
export const API_URL_lideres_profit_update= `${BASE_URL}/api/lider_profits`;

export const API_URL_utilidad_partner_curso_abierto = `${BASE_URL}/api/utilidad-partner-curso-abierto/`;
export const API_URL_utilidad_partner_curso_abierto_filter = `${BASE_URL}/api/utilidad-partner-curso-abierto/filter/`;

export const API_URL_vendors = `${BASE_URL}/api/vendors/`;
export const API_URL_vendors_detail = `${BASE_URL}/api/vendors/`; 

//invoice
export const API_URL_invoice = `${BASE_URL}/api/create-invoice`;

//analytics
export const API_URL_batch_summary = `${BASE_URL}/api/batches/summary/`;
export const API_URL_product_sales = `${BASE_URL}/api/product-sales`; 
export const API_URL_online_batches = `${BASE_URL}/api/batches_online/`;


export const API_URL_lssi_online_order_transactions_with_items = `${BASE_URL}/api/transactions/lssi-online-orders-with-items/`;

//Subproyectos
export const API_URL_subproyectos= `${BASE_URL}/api/subproyectos/`;

//Batch Proyectos
export const API_URL_batch_proyectos= `${BASE_URL}/api/batches_proyecto/`;
export const API_URL_batch_subproyectos= `${BASE_URL}/api/batches_subproyecto/`;

//Proyecto Summary
export const API_URL_proyecto_summary = `${BASE_URL}/api/proyecto-summary/`;

//Instructor Emails
export const API_URL_instructores_email = `${BASE_URL}/api/instructores-email/`;

// --- : Sede Subcategories ---
export const API_URL_SEDE_SUBCATS = `${BASE_URL}/api/sede-subcategories/`;

// (Optional) helper to fetch sedes with their subcategorías embedded
export const buildSedesWithSubsUrl = () => `${API_URL_sedes}?embed=subcategories`;

// --- Business Intelligence ---
export const API_URL_BI_SUMMARY = `${BASE_URL}/api/bi/summary/`;
export const API_URL_BI_VALUE_STREAM = `${BASE_URL}/api/bi/value-stream/`;
export const API_URL_BI_TIMELINE = `${BASE_URL}/api/bi/timeline/`;
export const API_URL_BI_PROJECTS = `${BASE_URL}/api/bi/projects/`;
export const API_URL_BI_CURRENCY_EXPOSURE = `${BASE_URL}/api/bi/currency-exposure/`;
export const API_URL_BI_WEEKLY_SUMMARY = `${BASE_URL}/api/bi/weekly-summary/`;
export const API_URL_BI_WEEKLY_ANALYSIS = `${BASE_URL}/api/bi/weekly-analysis/`;

// --- Passkeys Authentication ---
export const PASSKEY_API_BASE = `${BASE_URL}/api/passkeys`;

// --- Users (admin) ---
export const API_URL_users = `${BASE_URL}/Backend/users/`;

// --- Password reset ---
export const API_URL_forgot_password = `${BASE_URL}/api/auth/forgot-password/`;
export const API_URL_reset_password = `${BASE_URL}/api/auth/reset-password/`;
export const API_URL_admin_set_password = `${BASE_URL}/api/auth/admin-set-password/`;

// --- Client bulk import ---
export const API_URL_clients_import = `${BASE_URL}/api/clients/import/`;

// --- Chatbot ---
export const API_URL_chatbot_access = `${BASE_URL}/api/chatbot/access/`;
export const API_URL_chatbot_chat = `${BASE_URL}/api/chatbot/chat/`;
export const API_URL_chatbot_conversations = `${BASE_URL}/api/chatbot/conversations/`;
export const API_URL_chatbot_admin_conversations = `${BASE_URL}/api/chatbot/admin/conversations/`;
export const API_URL_chatbot_admin_tool_gaps = `${BASE_URL}/api/chatbot/admin/tool-gaps/`;
export const API_URL_chatbot_admin_user_sede_access = `${BASE_URL}/api/chatbot/admin/user-sede-access/`;
